// Cart drawer "Complete your outfit" quick-add.
(function () {
  function addVariant(id, btn) {
    var drawer = document.querySelector('cart-drawer');
    var trigger = btn.closest('.vc-up') ? btn.closest('.vc-up').querySelector('.vc-up__add') : btn;
    trigger.classList.add('is-loading');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && drawer && drawer.renderContents) {
          drawer.renderContents(data);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { trigger.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-vc-toggle]');
    if (toggle) {
      var sizes = toggle.parentElement.querySelector('.vc-up__sizes');
      if (sizes) {
        sizes.hidden = !sizes.hidden;
        toggle.setAttribute('aria-expanded', String(!sizes.hidden));
      }
      return;
    }
    var add = e.target.closest('[data-vc-add]');
    if (add && !add.disabled) addVariant(add.getAttribute('data-vc-add'), add);
  });
})();
